import axios from 'axios';

const CAPTURE_API_BASE_URL = process.env.REACT_APP_CAPTURE_API_BASE_URL || '';

// Note: Authorization header is injected automatically by the global axios
// interceptor in services/api.js (Supabase token injection).

export async function runExtraction(documentId) {
  const url = `${CAPTURE_API_BASE_URL}/api/capture/documents/${documentId}/extract`;
  return (await axios.post(url)).data;
}

export async function getExtractedFields(documentId) {
  const url = `${CAPTURE_API_BASE_URL}/api/capture/documents/${documentId}/extracted-fields`;
  return (await axios.get(url)).data;
}

export async function getLineItems(documentId) {
  const url = `${CAPTURE_API_BASE_URL}/api/capture/documents/${documentId}/line-items`;
  return (await axios.get(url)).data;
}

export async function updateLineItem(documentId, lineItemId, updates) {
  const url = `${CAPTURE_API_BASE_URL}/api/capture/documents/${documentId}/line-items/${lineItemId}`;
  return (await axios.put(url, updates)).data;
}

export async function addLineItem(documentId, item) {
  const url = `${CAPTURE_API_BASE_URL}/api/capture/documents/${documentId}/line-items`;
  return (await axios.post(url, item)).data;
}

export async function deleteLineItem(documentId, lineItemId) {
  const url = `${CAPTURE_API_BASE_URL}/api/capture/documents/${documentId}/line-items/${lineItemId}`;
  return (await axios.delete(url)).data;
}

export async function getDocumentStatus(documentId) {
  const url = `${CAPTURE_API_BASE_URL}/api/capture/documents/${documentId}`;
  return (await axios.get(url)).data;
}

export async function exportDocument(documentId, format = 'json') {
  const url = `${CAPTURE_API_BASE_URL}/api/capture/export/${documentId}?format=${format}`;
  return axios.get(url, { responseType: 'blob' });
}

export async function exportDocumentJSON(documentId) {
  const url = `${CAPTURE_API_BASE_URL}/api/capture/export/${documentId}?format=json`;
  return (await axios.get(url)).data;
}

// profileId: optional vendor profile override for mode 'reextract'; the route
// reads it as profile_id. Omitted from the body when not given.
export async function reclassifyDocument(documentId, mode = 'classify', profileId) {
  const url = `${CAPTURE_API_BASE_URL}/api/capture/documents/${documentId}/reclassify`;
  const body = profileId ? { mode, profile_id: profileId } : { mode };
  return (await axios.post(url, body)).data;
}

export async function getDiagnostics(documentId) {
  const url = `${CAPTURE_API_BASE_URL}/api/capture/documents/${documentId}/diagnostics`;
  return (await axios.get(url)).data;
}

export async function publishToLibrary(documentId) {
  const url = `${CAPTURE_API_BASE_URL}/api/capture/documents/${documentId}/publish`;
  try {
    return (await axios.post(url)).data;
  } catch (err) {
    // Gracefully handle capture-app not having this endpoint yet
    const status = err?.response?.status;
    if (status === 404) {
      return { ok: false, notImplemented: true, error: 'Publish endpoint not implemented yet' };
    }
    throw err;
  }
}
